import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class IdeasTableCellStatusComponent extends Component {
  @service betaToggle;

  get idea() {
    return this.args.idea;
  }

  @action
  handleStatusChange(idea, status) {
    idea.status = status.value;
    idea.save();
  }
}
